<template>
  <div class="container">
    <div class="header">
      <div class="title">核對資料</div>
      <div class="wrapList">
        <div
          class="item acea-row row-between-wrapper"
          :class="item.uid === userInfo.uid ? 'on' : ''"
          v-for="(item, index) in switchUserInfo"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <div class="pictrue">
                <img :src="item.avatar" />
              </div>
            </div>
            <div class="text">
              <div class="name line1">{{ item.nickname }}</div>
              <div class="phone">綁定手機號：{{ item.phone }}</div>
            </div>
          </div>
          <div
            class="currentBnt acea-row row-center-wrapper font-color-red"
            v-if="item.uid === userInfo.uid"
          ></div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>暱稱</div>
        <div class="input user-name">
          <input type="text" v-model="userInfo.nickname" />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>ID號</div>
        <div class="input acea-row row-between-wrapper">
          <input type="text" :value="userInfo.uid" disabled class="id" /><span
            class="iconfont icon-suozi"
          ></span>
        </div>
      </div>
    </div>
    <div class="form-box">
      <div class="title-doctor">填寫信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="真實姓名" prop="real_name">
          <el-input v-model="ruleForm.real_name"></el-input>
        </el-form-item>
        <el-form-item label="手機號碼" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="管理級別" prop="certification_type">
          <el-select v-model="ruleForm.certification_type">
            <el-option
              label="醫生"
              value="醫生"
              v-if="certification_type > 2"
            ></el-option>
            <el-option
              label="代表"
              value="代表"
              v-if="certification_type > 3"
            ></el-option>
            <el-option
              label="代理"
              value="代理"
              v-if="certification_type > 4"
            ></el-option>
            <el-option
              label="省代"
              value="省代"
              v-if="certification_type > 5"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣率" prop="brokerage">
          <el-input v-model="ruleForm.brokerage"></el-input>
        </el-form-item>
        <el-form-item
          label="所屬醫院"
          prop="hospital"
          v-if="ruleForm.certification_type == '醫生'"
        >
          <el-input v-model="ruleForm.hospital"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit('ruleForm')">
      保存修改
    </div>
    <div class="modifyBnt bg-color-gray" @click="unbind()" v-if="showUnbind">
      解除綁定
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  getNextUserInfo,
  userSpreadEdit,
  getUser,
  userUnbind
} from "@api/user";
// import { Message } from "element-ui";
export default {
  name: "BusinessUserInfo",
  data() {
    return {
      certification_type: "",
      avatar: "",
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0,
      userInfo: {},
      showUnbind: this.$route.query.grade == "0" ? true : false,
      ruleForm: {
        real_name: "",
        phone: "",
        certification_type: "",
        brokerage: ""
      },
      rules: {
        real_name: [{ required: true, message: "請輸入名字", trigger: "blur" }],
        phone: [
          { required: true, message: "請輸入手機號碼", trigger: "blur" },
          { min: 11, max: 11, message: "長度為11個數字", trigger: "blur" }
        ],
        certification_type: [
          { required: true, message: "請選擇分銷級別", trigger: "blur" }
        ],
        brokerage: [{ required: true, message: "請輸入扣率", trigger: "blur" }]
      },
      provinceVal: "",
      cityVal: "", //拼接医院的市
      hospitalOptions: [], // 医院数据
      departmentOptions: [] // 科室数据
    };
  },
  created() {},
  async mounted() {
    this.getSpread();

    const res = await axios.get("/hospital.json", {});
    this.$set(this, "hospitalOptions", res.data.hospital);
    this.$set(this, "departmentOptions", res.data.department);
  },
  computed: {},
  methods: {
    getSpread() {
      //生命周期里接收参数
      this.id = this.$route.query.id;
      this.certification_type = this.$route.query.certification_type;
      if (!this.id) {
        getUser().then(res => {
          let id = res.data.uid;
          //this.certification_type = res.data.certification_type;
          getNextUserInfo(id).then(res => {
            this.userInfo = res.data;
            this.ruleForm = res.data;
            //this.certification_type = res.data.certification_type;
            switch (this.ruleForm.certification_type) {
              case 0:
                this.ruleForm.certification_type = "无";
                break;
              case 1:
                this.ruleForm.certification_type = "患者";
                break;
              case 2:
                this.ruleForm.certification_type = "醫生";
                break;
              case 3:
                this.ruleForm.certification_type = "代表";
                break;
              case 4:
                this.ruleForm.certification_type = "代理";
                break;
              case 5:
                this.ruleForm.certification_type = "省代";
                break;
            }
            this.switchUserInfo.forEach((item, index) => {
              if (item.uid == res.data.uid) {
                this.switchUserInfo.splice(index, 1);
              }
            });
            this.switchUserInfo.splice(0, this.switchUserInfo.length);
            this.switchUserInfo.push(res.data);
          });
        });
      } else {
        // 接受参数关键代码;
        getNextUserInfo(this.id).then(res => {
          this.userInfo = res.data;
          this.ruleForm = res.data;
          //this.certification_type = this.ruleForm.certification_type;
          switch (this.ruleForm.certification_type) {
            case 0:
              this.ruleForm.certification_type = "无";
              break;
            case 1:
              this.ruleForm.certification_type = "患者";
              break;
            case 2:
              this.ruleForm.certification_type = "醫生";
              break;
            case 3:
              this.ruleForm.certification_type = "代表";
              break;
            case 4:
              this.ruleForm.certification_type = "代理";
              break;
            case 5:
              this.ruleForm.certification_type = "省代";
              break;
          }
          this.switchUserInfo.splice(0, this.switchUserInfo.length);
          this.switchUserInfo.push(res.data);
        });
      }
    },
    submit: function(ruleForm) {
      let that = this;
      that.$refs[ruleForm].validate(valid => {
        if (valid) {
          let formData = {
            uid: that.id
          };
          Object.assign(formData, that.ruleForm);
          let newHospital =
            this.provinceVal + "/" + this.cityVal + "/" + formData.hospital;
          switch (formData["certification_type"]) {
            case "无":
              formData["certification_type"] = 0;
              break;
            case "患者":
              formData["certification_type"] = 1;
              break;
            case "醫生":
              formData["certification_type"] = 2;
              break;
            case "代表":
              formData["certification_type"] = 3;
              break;
            case "代理":
              formData["certification_type"] = 4;
              break;
            case "省代":
              formData["certification_type"] = 5;
              break;
          }
          formData["hospital"] = newHospital; //拼接医院省市
          userSpreadEdit(formData).then(res => {
            that.$Message.success(res.msg);
            that.$router.replace("/home/businessTotal");
          });
          // doctorEdit(formData).then(res => {
          //   if (res.msg == "修改成功") {
          //     that.$dialog.toast({
          //       mes: "修改成功"
          //     });
          //     this.roturBack();
          //   } else {
          //     that.$dialog.toast({
          //       mes: "修改失败请重新提交"
          //     });
          //   }
          // });
        } else {
          return false;
        }
      });
    },
    roturBack() {
      this.$router.go(-1);
    },
    // 子组件返回所选中的医院名称
    hospitalName(hospitalVal, cityVal, provinceVal) {
      this.provinceVal = provinceVal;
      this.cityVal = cityVal;
      this.ruleForm.hospital = hospitalVal;
    },
    // 子组件返回所选中的科室名称
    departmentName(val) {
      this.ruleForm.department = val;
    },
    unbind() {
      let that = this;
      // this.$dialog.confirm({
      //   title: "是否解除绑定？",
      //   showConfirmButton: true
      // });
      this.$dialog.confirm({
        mes: "是否解除綁定?",
        opts: [
          {
            txt: "是",
            color: "red",
            callback: () => {
              userUnbind(this.userInfo.uid)
                .then(res => {
                  that.$dialog.success(res.msg).then(() => {
                    that.$router.replace("/home/businessTotal");
                  });
                })
                .catch(err => {
                  this.$dialog.error(err.msg);
                });
            }
          },
          {
            txt: "否",
            color: false,
            callback: () => {
              that.$dialog.toast({
                mes: "已取消"
              });
            }
          }
        ]
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  .header
    .title
      font-size 20px
    .wrapList
      border 1px grey solid
      border-radius 5px
      .item
        .picTxt
          display flex
          align-items center
          .pictrue
            margin 5px 10px
            img
              width 100px
              height 100px
  .list
    margin 5px 0
    .item
      display flex
      align-items center
      font-size 14px
      .input
        margin-left 10px
  .form-box
    .title-doctor
      font-size 20px
  .modifyBnt
    border-radius 15px
    padding 5px 0
    width 300px
    text-align center
    color white
    margin 10px auto
    cursor pointer
  .bg-color-red
    background-color red
  .bg-color-gray
    background-color gray
</style>
